import { NodeIds, NodeTypeKeys } from '../../utils/NodeTypeKeys';
import { Position } from '../../types';
import { Leaf } from '../Leaf';
import { Leaf as ILeaf } from '../../types';

const triggerAllowedNodeTypes = [
  NodeTypeKeys.displayWebContentNodeType,
  NodeTypeKeys.dropzoneNodeType,
  NodeTypeKeys.branchControlNodeType,
];

export class TriggerNode extends Leaf {
  public constructor(
    currentAllowedNodeTypes: string[] = triggerAllowedNodeTypes,
    position: Position = undefined,
    next: ILeaf = undefined,
    isHidden: boolean = undefined,
  ) {
    super(NodeIds.trigger, NodeTypeKeys.triggerNodeType, currentAllowedNodeTypes, {
      position,
      isHidden,
      next,
    });
  }

  public hideNodes() {
    super.hideNodes();
    this.hidden.show();

    return this;
  }
}
